import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { ProvisionItem } from '../../models/provisionitem';

@Pipe({
  standalone: false,
  name: 'searchprovisionitems'
})

@Injectable()
export class SearchProvisionItemsPipe implements PipeTransform {
  transform(items: ProvisionItem[], value: string): any[] {
    if (!items) return [];
    if (items.length === 0) return [];
    if (value === '') return items;

    items = items.filter(it => (it.Type == 'FPC' && it.Family.search(value) > -1)
      || (it.Execution != null ? it.Execution.toLowerCase().search(value!.toLowerCase()) > -1 : '')
      || (it.ExecutionDescription != null ? it.ExecutionDescription.toLowerCase().search(value!.toLowerCase()) > -1 : '')
      || (it.FamilyDescription != null ? it.FamilyDescription.toLowerCase().search(value!.toLowerCase()) > -1 : ''));
      
    return items;
  }
}